/* AGENTLE v8 — storefront behaviour (no dependencies) */
(function () {
  'use strict';
  var T = window.agTheme || { routes: {}, strings: {} };
  var R = T.routes || {};
  var S = T.strings || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var mqDesk = window.matchMedia('(min-width: 1100px)');
  function throttle(fn, ms) { var t = null; return function () { if (t) return; t = setTimeout(function () { t = null; fn(); }, ms || 80); }; }
  function onMq(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }

  /* ---------------- toast ---------------- */
  var toastEl = null;
  function toast(msg) {
    if (!msg) return;
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'ag-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3400);
  }

  /* ---------------- header offset / scroll state ---------------- */
  var header = $('[data-ag-header]');
  function setOffset() {
    if (!header) return;
    var b = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--hdr-offset', Math.max(0, Math.round(b)) + 'px');
  }
  window.addEventListener('scroll', throttle(function () {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 4);
    setOffset();
  }, 60), { passive: true });
  window.addEventListener('resize', throttle(setOffset, 120));
  setOffset();

  function anyOpen() {
    return !!$('.ag-drawer.is-open, .ag-search.is-open, .ag-cart.is-open');
  }
  function syncLock() { document.body.classList.toggle('ag-lock', anyOpen()); }

  /* ---------------- desktop navigation panels ---------------- */
  function closeAllNav(except) {
    $$('[data-ag-nav-item].is-open').forEach(function (i) { if (i !== except && i._agClose) i._agClose(); });
  }
  $$('[data-ag-nav-item].has-panel').forEach(function (item) {
    var link = item.querySelector('.ag-nav__link');
    var timer = null;
    function open() { clearTimeout(timer); closeAllNav(item); item.classList.add('is-open'); if (link) link.setAttribute('aria-expanded', 'true'); }
    function close() { clearTimeout(timer); item.classList.remove('is-open'); if (link) link.setAttribute('aria-expanded', 'false'); }
    item._agClose = close;
    item.addEventListener('mouseenter', function () { if (!canHover) return; clearTimeout(timer); timer = setTimeout(open, 80); });
    item.addEventListener('mouseleave', function () { if (!canHover) return; clearTimeout(timer); timer = setTimeout(close, 160); });
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
    if (link) {
      link.addEventListener('click', function (e) {
        if (!canHover && !item.classList.contains('is-open')) { e.preventDefault(); open(); }
      });
      link.addEventListener('keydown', function (e) {
        if ((e.key === 'ArrowDown' || e.key === ' ') && !item.classList.contains('is-open')) {
          e.preventDefault(); open();
          var first = item.querySelector('.ag-mega a, .ag-drop a'); if (first) first.focus();
        }
      });
    }
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-ag-nav-item]')) closeAllNav(); });

  /* ---------------- mobile drawer ---------------- */
  var drawer = $('[data-ag-drawer]');
  var burger = $('[data-ag-drawer-toggle]');
  function openDrawer() {
    if (!drawer) return;
    closeSearch(); closeCart(); setOffset();
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    if (header) header.classList.add('is-drawer-open');
    syncLock();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (header) header.classList.remove('is-drawer-open');
    syncLock();
  }
  if (burger) burger.addEventListener('click', function () { if (drawer && drawer.classList.contains('is-open')) closeDrawer(); else openDrawer(); });
  onMq(mqDesk, function (e) { if (e.matches) closeDrawer(); });

  /* ---------------- search overlay + predictive search ---------------- */
  var search = $('[data-ag-search]');
  var sInput = $('[data-ag-search-input]');
  var sResults = $('[data-ag-search-results]');
  var sDefault = sResults ? sResults.innerHTML : '';
  var sTimer = null, sCtrl = null, sNoPredictive = /^th/i.test(document.documentElement.lang || '');
  function openSearch() {
    if (!search) return;
    closeDrawer(); closeAllNav(); closeCart(); setOffset();
    search.classList.add('is-open'); search.setAttribute('aria-hidden', 'false'); syncLock();
    setTimeout(function () { if (sInput) sInput.focus(); }, 80);
  }
  function closeSearch() {
    if (!search || !search.classList.contains('is-open')) return;
    search.classList.remove('is-open'); search.setAttribute('aria-hidden', 'true'); syncLock();
  }
  $$('[data-ag-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
  $$('[data-ag-search-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeSearch(); }); });
  if (sInput && sResults && R.predictive) {
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (!q) { sResults.innerHTML = sDefault; paint(); return; }
      sTimer = setTimeout(function () {
        if (sCtrl) sCtrl.abort();
        sCtrl = window.AbortController ? new AbortController() : null;
        search.classList.add('is-loading');
        var opts = sCtrl ? { signal: sCtrl.signal } : {};
        var url = R.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search';
        /* Predictive search does not support every language (e.g. Thai): fall back to the regular search results */
        var fallback = (R.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last&section_id=predictive-search';
        var load = function (u) {
          return fetch(u, opts)
            .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
            .then(function (html) {
              var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ag-predictive]');
              if (!sec) throw new Error('empty');
              return sec.outerHTML;
            });
        };
        var job = sNoPredictive ? load(fallback) : load(url).catch(function (err) {
          if (err && err.name === 'AbortError') throw err;
          sNoPredictive = true;
          return load(fallback);
        });
        job.then(function (html) {
            sResults.innerHTML = html;
            search.classList.remove('is-loading');
            paint();
          })
          .catch(function (err) { if (!err || err.name !== 'AbortError') search.classList.remove('is-loading'); });
      }, 220);
    });
  }

  /* ---------------- cart (AJAX + drawer) ---------------- */
  function cartEl() { return $('[data-ag-cart]'); }
  function openCart() {
    var c = cartEl(); if (!c || T.template === 'cart') return;
    closeDrawer(); closeSearch(); closeAllNav();
    c.classList.add('is-open'); c.setAttribute('aria-hidden', 'false'); syncLock();
    var p = c.querySelector('.ag-cart__panel'); if (p) { try { p.focus({ preventScroll: true }); } catch (e) { p.focus(); } }
  }
  function closeCart() {
    var c = cartEl(); if (!c || !c.classList.contains('is-open')) return;
    c.classList.remove('is-open'); c.setAttribute('aria-hidden', 'true'); syncLock();
  }
  function updateCount(n) {
    $$('[data-ag-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function renderSections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('[data-ag-cart]');
    var cur = cartEl();
    if (fresh && cur) {
      var wasOpen = cur.classList.contains('is-open');
      fresh.classList.toggle('is-open', wasOpen);
      fresh.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
      cur.parentNode.replaceChild(fresh, cur);
      updateCount(parseInt(fresh.getAttribute('data-count') || '0', 10));
    }
    paint();
  }
  function jsonOrThrow(r) { return r.json().then(function (d) { if (!r.ok || d.status) throw d; return d; }); }
  function changeLine(key, qty) {
    var c = cartEl(); if (c) c.classList.add('is-busy');
    fetch(R.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(jsonOrThrow)
      .then(function (d) {
        if (T.template === 'cart') { window.location.reload(); return; }
        renderSections(d.sections);
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || S.error); var c2 = cartEl(); if (c2) c2.classList.remove('is-busy'); });
  }
  function addToCart(form, btn) {
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    var label = btn ? btn.querySelector('[data-ag-btn-label]') : null;
    var original = label ? label.textContent : null;
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    if (label && S.adding) label.textContent = S.adding;
    return fetch(R.cart_add + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(jsonOrThrow)
      .then(function (d) {
        if (T.template === 'cart') { window.location.reload(); return; }
        renderSections(d.sections);
        if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1400); }
        openCart();
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || S.error); })
      .then(function () {
        if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); }
        if (label && original !== null) label.textContent = original;
      });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-ag-add-form]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    addToCart(f, f.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-ag-cart-open]');
    if (open && cartEl() && T.template !== 'cart') { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-ag-cart-close]')) { e.preventDefault(); closeCart(); return; }
    var q = e.target.closest('[data-ag-qty]');
    if (q) {
      var line = q.closest('[data-key]');
      if (line) { e.preventDefault(); changeLine(line.getAttribute('data-key'), parseInt(q.getAttribute('data-ag-qty'), 10)); }
      return;
    }
    var st = e.target.closest('[data-ag-step]');
    if (st) {
      var input = st.parentNode.querySelector('input');
      if (input) { var v = (parseInt(input.value, 10) || 1) + parseInt(st.getAttribute('data-ag-step'), 10); input.value = Math.max(1, v); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllNav(); closeDrawer(); closeSearch(); closeCart(); }
  });

  /* ---------------- carousels ---------------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-ag-track]'); if (!track || root._agInit) return;
    root._agInit = true;
    var prev = root.querySelector('[data-ag-prev]');
    var next = root.querySelector('[data-ag-next]');
    var dotsEl = root.querySelector('[data-ag-dots]');
    var n = 1;
    function step() { var first = track.children[0]; if (!first) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap) || 0; var per = Math.max(1, Math.floor((track.clientWidth + gap) / (first.getBoundingClientRect().width + gap))); return per * (first.getBoundingClientRect().width + gap); }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function active() { var m = maxScroll(); if (m <= 2) return 0; if (track.scrollLeft >= m - 4) return n - 1; return Math.min(n - 1, Math.round(track.scrollLeft / step())); }
    function build() {
      var m = maxScroll();
      n = m > 2 ? Math.ceil(m / step()) + 1 : 1;
      if (dotsEl) {
        dotsEl.innerHTML = '';
        dotsEl.hidden = n <= 1;
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button'); b.type = 'button';
          b.setAttribute('aria-label', (S.slide || 'Slide') + ' ' + (i + 1));
          (function (k) { b.addEventListener('click', function () { track.scrollTo({ left: k === n - 1 ? maxScroll() : k * step(), behavior: reduceMotion ? 'auto' : 'smooth' }); }); })(i);
          dotsEl.appendChild(b);
        }
      }
      update();
    }
    function update() {
      var a = active();
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft >= maxScroll() - 4;
      if (dotsEl) $$('button', dotsEl).forEach(function (b, i) { b.setAttribute('aria-current', i === a ? 'true' : 'false'); });
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', throttle(update, 70), { passive: true });
    window.addEventListener('resize', throttle(build, 150));
    root._agRefresh = build;
    build();
  }
  $$('[data-ag-carousel]').forEach(initCarousel);

  /* ---------------- tabs ---------------- */
  $$('[data-ag-tabs]').forEach(function (root) {
    var btns = $$('[role="tab"]', root);
    var panels = $$('[role="tabpanel"]', root);
    function select(i, focus) {
      btns.forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); b.tabIndex = j === i ? 0 : -1; });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      var c = panels[i] && panels[i].querySelector('[data-ag-carousel]');
      if (c) { if (!c._agInit) initCarousel(c); else if (c._agRefresh) c._agRefresh(); }
      if (focus) btns[i].focus();
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % btns.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + btns.length) % btns.length, true); }
      });
    });
  });

  /* ---------------- slideshow ---------------- */
  $$('[data-ag-slideshow]').forEach(function (root) {
    var slides = $$('.ag-ss__slide', root);
    if (slides.length < 2) return;
    var dots = $$('[data-ag-ss-dot]', root);
    var i = 0, timer = null;
    var interval = (parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    function show(k) {
      i = (k + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); s.setAttribute('aria-hidden', j === i ? 'false' : 'true'); if (j === i) s.removeAttribute('inert'); else s.setAttribute('inert', ''); });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    function stop() { clearInterval(timer); timer = null; }
    function play() { if (!auto) return; stop(); timer = setInterval(function () { show(i + 1); }, interval); }
    var pv = root.querySelector('[data-ag-ss-prev]'), nx = root.querySelector('[data-ag-ss-next]');
    if (pv) pv.addEventListener('click', function () { show(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { show(i + 1); play(); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); play(); }); });
    if (canHover) { root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play); }
    root.addEventListener('focusin', stop);
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { show(dx < 0 ? i + 1 : i - 1); play(); }
      x0 = null;
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    show(0); play();
  });

  /* ---------------- product gallery ---------------- */
  $$('[data-ag-gallery]').forEach(function (root) {
    var track = root.querySelector('[data-ag-gal-track]'); if (!track) return;
    var slides = $$('.ag-gal__slide', root);
    var thumbs = $$('[data-ag-thumb]', root);
    var dots = $$('[data-ag-gal-dot]', root);
    var counter = root.querySelector('[data-ag-gal-count]');
    function cur() { return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth))); }
    function go(k) { k = Math.max(0, Math.min(slides.length - 1, k)); track.scrollTo({ left: k * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); }
    function sync() {
      var c = cur();
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === c ? 'true' : 'false'); });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === c ? 'true' : 'false'); });
      if (counter) counter.textContent = (c + 1) + ' / ' + slides.length;
      var at = thumbs[c]; if (at && at.parentNode && at.parentNode.scrollTo) { var p = at.parentNode; var top = at.offsetTop - p.clientHeight / 2 + at.clientHeight / 2; p.scrollTo({ top: top, behavior: 'smooth' }); }
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    var pv = root.querySelector('[data-ag-gal-prev]'), nx = root.querySelector('[data-ag-gal-next]');
    if (pv) pv.addEventListener('click', function () { go(cur() - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur() + 1); });
    track.addEventListener('scroll', throttle(sync, 60), { passive: true });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur() + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur() - 1); } });
    sync();
  });

  /* ---------------- product form: variants + sticky bar ---------------- */
  $$('[data-ag-product]').forEach(function (root) {
    var form = root.querySelector('[data-ag-add-form]');
    var dataEl = root.querySelector('[data-ag-variants]');
    if (form && dataEl) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      var idInput = form.querySelector('[name="id"]');
      var btn = form.querySelector('[data-ag-main-atc]');
      var label = btn ? btn.querySelector('[data-ag-btn-label]') : null;
      root.addEventListener('change', function (e) {
        if (!e.target.closest('[data-ag-opt]')) return;
        var chosen = $$('[data-ag-opt]', root).map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === chosen[k]; }); });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        $$('[data-ag-opt-label]', root).forEach(function (el, k) { el.textContent = chosen[k] || ''; });
        if (btn) { btn.disabled = !v.available; if (label) label.textContent = v.available ? S.addToCart : S.soldOut; }
        if (window.history && history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
        var priceWrap = root.querySelector('[data-ag-variant-price]');
        if (priceWrap && v.price_html) { priceWrap.innerHTML = v.price_html; paint(); }
      });
    }
  });
  var satc = $('[data-ag-satc]');
  var mainBtn = $('[data-ag-main-atc]');
  if (satc && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var on = !en.isIntersecting && en.boundingClientRect.top < 0;
        satc.classList.toggle('is-on', on);
        document.body.classList.toggle('has-satc', on);
      });
    }).observe(mainBtn);
    var sb = satc.querySelector('[data-ag-satc-btn]');
    if (sb) sb.addEventListener('click', function () {
      var f = mainBtn.closest('form');
      if (!f) return;
      if (f.requestSubmit) f.requestSubmit(mainBtn); else mainBtn.click();
    });
  }

  /* ---------------- announcement rotator ---------------- */
  $$('[data-ag-ann]').forEach(function (root) {
    var msgs = $$('.ag-ann__msg', root);
    if (msgs.length < 2 || reduceMotion) return;
    var i = 0;
    setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 4800);
  });

  /* ---------------- footer accordions: closed on phones ---------------- */
  function syncFooter() {
    var mobile = window.innerWidth < 750;
    $$('.ag-ftr__acc').forEach(function (d) { if (mobile) { if (!d._agTouched) d.open = false; } else { d.open = true; } });
  }
  $$('.ag-ftr__acc > summary').forEach(function (s) { s.addEventListener('click', function () { s.parentNode._agTouched = true; }); });
  syncFooter();
  window.addEventListener('resize', throttle(syncFooter, 200));

  /* ---------------- reveal on scroll ---------------- */
  var reveals = $$('.ag-reveal');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------------- USD estimate (international market only) ---------------- */
  function paint() { if (window.agPaint) window.agPaint(); }
  (function initCurrency() {
    if (T.isTh) return;
    var rate = 0.0302;
    function pref() { try { return localStorage.getItem('agentleCurPref') || 'USD'; } catch (e) { return 'USD'; } }
    function setPref(v) { try { localStorage.setItem('agentleCurPref', v); } catch (e) {} }
    function num(t) { return parseFloat(String(t).replace(/[^\d.\-]/g, '')); }
    function usd(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
    function thb(n) { return '฿' + Math.round(n).toLocaleString('en-US'); }
    window.agPaint = function () {
      var mode = pref(), stamp = mode + '@' + rate;
      $$('span.now, span.was').forEach(function (el) {
        if (el.getAttribute('data-cur-stamp') === stamp) return;
        var raw = el.getAttribute('data-thb');
        if (raw === null) { raw = el.textContent; el.setAttribute('data-thb', raw); }
        var v = num(raw); if (isNaN(v)) return;
        el.setAttribute('data-cur-stamp', stamp);
        el.innerHTML = mode === 'USD'
          ? '<span class="ag-p">' + usd(v * rate) + '</span><span class="ag-s">' + thb(v) + '</span>'
          : '<span class="ag-p">' + thb(v) + '</span><span class="ag-s">≈ ' + usd(v * rate) + '</span>';
        el.title = (S.chargedThb || '') + ' ' + thb(v) + ' ≈ ' + usd(v * rate);
      });
      $$('[data-ag-cur-switch]').forEach(function (sw) {
        sw.hidden = false;
        $$('button', sw).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cur') === mode ? 'true' : 'false'); });
      });
    };
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ag-cur-switch] button');
      if (!b) return;
      setPref(b.getAttribute('data-cur')); window.agPaint();
    });
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('agentleRateUSD') || 'null'); } catch (e) {}
    if (cached && cached.r && (Date.now() - cached.t) < 3600000) { rate = cached.r; window.agPaint(); return; }
    window.agPaint();
    fetch('https://open.er-api.com/v6/latest/THB')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.result === 'success' && d.rates && d.rates.USD) {
          rate = d.rates.USD;
          try { sessionStorage.setItem('agentleRateUSD', JSON.stringify({ t: Date.now(), r: rate })); } catch (e) {}
          $$('[data-cur-stamp]').forEach(function (el) { el.removeAttribute('data-cur-stamp'); });
          window.agPaint();
        }
      })
      .catch(function () {});
  })();

  window.agTheme = T;
  T.openCart = openCart; T.closeCart = closeCart; T.toast = toast; T.paint = paint;
})();
